import { PageHero, CTASection } from "@/components/Bits";
import { Reveal } from "@/components/Reveal";
import { Target, Eye } from "lucide-react";
import { IMAGES } from "@/lib/data";

export default function MissionVision() {
  return (
    <div>
      <PageHero index="03 — Mission & Vision" title={<>Precision.<br />Trust. Legacy.</>} subtitle="The principles that guide five decades of manufacturing." image={IMAGES.plantInterior} />

      <section className="max-w-[1500px] mx-auto px-5 md:px-10 py-24 md:py-32 grid lg:grid-cols-2 gap-8">
        <Reveal>
          <div className="border border-[#DCE1E8] p-10 md:p-14 h-full bg-white" data-testid="mission-card">
            <Target size={40} className="text-[#1D4ED8]" />
            <div className="overline mt-8 mb-4">Our Mission</div>
            <p className="font-display font-medium text-2xl md:text-3xl tracking-tight leading-snug text-[#0E1626]">
              Provide reliable, precise and high-quality manufacturing solutions based on quality, precision, competitive pricing and on-time delivery.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="border border-[#DCE1E8] p-10 md:p-14 h-full bg-white" data-testid="vision-card">
            <Eye size={40} className="text-[#1D4ED8]" />
            <div className="overline mt-8 mb-4">Our Vision</div>
            <p className="font-display font-medium text-2xl md:text-3xl tracking-tight leading-snug text-[#0E1626]">
              Become a trusted long-term manufacturing partner for industries across India while continuing the legacy established by Jagjivanbhai Mevada.
            </p>
          </div>
        </Reveal>
      </section>

      <section className="border-t border-[#DCE1E8] bg-white">
        <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-20 grid md:grid-cols-3 gap-8">
          {["Quality", "Precision", "On-Time Delivery"].map((v, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="text-center md:text-left">
                <div className="font-display font-extrabold text-5xl md:text-6xl text-[#D3DAE3]">{String(i + 1).padStart(2, "0")}</div>
                <div className="font-display font-bold text-2xl tracking-tight mt-3 text-[#0E1626]">{v}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTASection />
    </div>
  );
}
